export default __webpack_public_path__ + "img/DonsRewardsLogo-01.png";